module.exports = __webpack_public_path__ + "8f10299ca9ffcde9b8f5ce88a4c350ac.MP3";